<div class="sz-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-szuro-sor">
      <span class="gj-honap">
        <button type="button" class="sz-gomb-ikon" (click)="hoLep(-1)" title="Előző hónap"><ion-icon name="chevron-back"></ion-icon></button>
        <select [(ngModel)]="ho" (ngModelChange)="frissit()"><option *ngFor="let h of honapok; let i = index" [ngValue]="i + 1">{{ ev }}. {{ h }}</option></select>
        <button type="button" class="sz-gomb-ikon" (click)="hoLep(1)" title="Következő hónap"><ion-icon name="chevron-forward"></ion-icon></button>
      </span>
      <span class="halvany" *ngIf="adat">általános normaköltség: <b>{{ fmt(adat.beallitas.normakoltseg_ft_km) }} Ft/km</b> · munkába járás: <b>{{ fmt(adat.beallitas.munkaba_ft_km) }} Ft/km</b></span>
      <span class="spacer"></span>
      <button type="button" class="ov-gomb" (click)="frissit()"><ion-icon name="refresh-outline"></ion-icon>Frissítés</button>
    </div>

    <div class="sz-ures" *ngIf="adat && !latszik.length">A hónapban egyik járműnek sincs útja vagy tankolása.</div>

    <div class="gj-elsz-kartyak" *ngIf="adat">
      <section class="gj-elsz-kartya" *ngFor="let j of latszik">
        <header>
          <div><b class="gj-rendszam">{{ j.jarmu.rendszam }}</b> <span class="halvany">{{ j.jarmu.gyartmany }} {{ j.jarmu.tipus }}</span></div>
          <span class="sz-allapot" [attr.data-a]="j.jarmu.magan ? 'var' : 'teljesitett'">{{ j.jarmu.magan ? 'saját (magán) autó' : 'céges autó' }}</span>
        </header>
        <div class="gj-elsz-sor halvany">
          norma: <b>{{ j.norma?.norma ? fmtMax(j.norma.norma) + ' l/100 km' : 'nincs' }}</b> ·
          NAV-ár: <b [class.gj-hiany]="j.ar == null">{{ j.ar == null ? 'hiányzik' : fmt(j.ar, 2) + ' Ft/l' }}</b> · {{ j.utak_db }} út
        </div>
        <table class="gj-szamok">
          <thead><tr><th></th><th class="num">km</th><th class="num">normás l</th><th class="num">normás Ft</th></tr></thead>
          <tbody>
            <tr><td>Üzleti</td><td class="num">{{ fmtMax(j.km.uzleti, 1) }}</td><td class="num">{{ fmtMax(j.liter.uzleti) }}</td><td class="num">{{ fmt(j.normas_ft.uzleti) }}</td></tr>
            <tr><td>Munkába járás</td><td class="num">{{ fmtMax(j.km.munkaba, 1) }}</td><td class="num">{{ fmtMax(j.liter.munkaba) }}</td><td class="num">{{ fmt(j.normas_ft.munkaba) }}</td></tr>
            <tr><td>Magán</td><td class="num">{{ fmtMax(j.km.magan, 1) }}</td><td class="num">{{ fmtMax(j.liter.magan) }}</td><td class="num">{{ fmt(j.normas_ft.magan) }}</td></tr>
            <tr class="osszeg-sor"><td><b>Összesen</b></td><td class="num"><b>{{ fmtMax(j.km.osszes, 1) }}</b></td><td class="num"><b>{{ fmtMax(j.liter.osszes) }}</b></td><td class="num"><b>{{ fmt(j.normas_ft.osszes) }}</b></td></tr>
          </tbody>
        </table>

        <!-- magánautó: térítés -->
        <div class="gj-tetelek" *ngIf="j.jarmu.magan">
          <div><span>Normás üzemanyag (üzleti)</span><b>{{ j.normas_ft.uzleti == null ? '—' : fmt(j.normas_ft.uzleti) + ' Ft' }}</b></div>
          <div><span>Általános normaköltség ({{ fmtMax(j.km.uzleti, 1) }} km × {{ fmt(adat.beallitas.normakoltseg_ft_km) }} Ft)</span><b>{{ fmt(j.normakoltseg_ft) }} Ft</b></div>
          <div class="kiemelt"><span>Hivatali használat térítése</span><b>{{ j.uzleti_terites_ft == null ? '—' : fmt(j.uzleti_terites_ft) + ' Ft' }}</b></div>
          <div><span>ebből kiküldetési rendelvényen</span><b>{{ fmtMax(j.rendelvenyen_km, 1) }} km</b></div>
          <div class="kiemelt"><span>Munkába járás ({{ fmtMax(j.km.munkaba, 1) }} km × {{ fmt(adat.beallitas.munkaba_ft_km) }} Ft)</span><b>{{ fmt(j.munkaba_ft) }} Ft</b></div>
        </div>
        <!-- céges autó: megtakarítás / túlfogyasztás -->
        <div class="gj-tetelek" *ngIf="!j.jarmu.magan">
          <div><span>Tankolás ({{ j.tankolt.db }} db)</span><b>{{ fmtMax(j.tankolt.liter) }} l · {{ fmt(j.tankolt.ft) }} Ft</b></div>
          <div><span>Normás fogyasztás (összes út)</span><b>{{ fmtMax(j.liter.osszes) }} l</b></div>
          <div class="kiemelt" *ngIf="j.kulonbseg_liter != null">
            <span>{{ j.kulonbseg_liter >= 0 ? 'Üzemanyag-megtakarítás' : 'Túlfogyasztás' }}</span>
            <b class="gj-elter" [class.plusz]="j.kulonbseg_liter >= 0" [class.minusz]="j.kulonbseg_liter < 0">{{ fmtMax(j.kulonbseg_liter < 0 ? -j.kulonbseg_liter : j.kulonbseg_liter) }} l{{ j.kulonbseg_ft != null ? ' · ' + fmt(j.kulonbseg_ft < 0 ? -j.kulonbseg_ft : j.kulonbseg_ft) + ' Ft' : '' }}</b>
          </div>
        </div>
        <!-- óraállás -->
        <div class="gj-tetelek">
          <div><span>Km-óra nyitó → záró</span><b>{{ j.ora.nyito ? fmt(j.ora.nyito.km) : '—' }} → {{ j.ora.zaro ? fmt(j.ora.zaro.km) : '—' }}{{ j.ora.ora_km != null ? ' (' + fmt(j.ora.ora_km) + ' km)' : '' }}</b></div>
          <div *ngIf="j.ora.elteres != null"><span>Eltérés a rögzített utaktól</span><b class="gj-elter" [class.minusz]="j.ora.elteres >= 1 || j.ora.elteres <= -1">{{ fmtMax(j.ora.elteres, 1) }} km</b></div>
        </div>
        <div class="gj-figyelem" *ngFor="let f of j.figyelmeztetesek"><ion-icon name="alert-circle-outline"></ion-icon><span>{{ f }}</span></div>
        <div class="gj-soforok" *ngIf="j.jarmu.magan && j.soforok.length > 1">
          <span class="halvany">Sofőrönként:</span>
          <span *ngFor="let s of j.soforok">{{ s.nev }}: üzleti {{ fmtMax(s.uzleti_km, 1) }} km, munkába {{ fmtMax(s.munkaba_km, 1) }} km ({{ fmt(s.munkaba_ft) }} Ft)</span>
        </div>
      </section>
    </div>
    <p class="halvany gj-lablec" *ngIf="uresek.length">Út nélkül a hónapban: {{ uresRendszamok }}</p>

    <!-- ═══ BÉR-ÁTADÁS ═══ -->
    <section class="gj-blokk" *ngIf="atad && (vanAtadhato || atad.atadasok.length)">
      <div class="gj-blokk-fej">
        <h3 class="sz-cim">Átadás a Bérbe <small class="halvany">– {{ ev }}. {{ honapok[ho - 1] }}</small></h3>
        <span class="spacer"></span>
        <button type="button" class="ov-gomb fo" *ngIf="ir && vanAtadhato" (click)="atadNyit()"><ion-icon name="arrow-redo-outline"></ion-icon>Átadás a Bérbe</button>
      </div>
      <div class="tabla-wrap" *ngIf="vanAtadhato">
        <table class="n-racs sz-racs">
          <thead><tr><th>Tétel</th><th>Kiküldött / sofőr</th><th>Részletek</th><th class="num">Összeg (Ft)</th><th>Állapot</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of atad.atadhato.rendelvenyek">
              <td>Kiküldetés <b>{{ r.sorszam }}</b></td><td>{{ r.sofor_nev }}</td>
              <td>{{ r.rendszam }} · {{ huDatum(r.tol) }}–{{ huDatum(r.ig) }} · {{ fmtMax(r.km, 1) }} km</td>
              <td class="num">{{ fmt(r.fizetendo_ft) }}</td>
              <td><span class="sz-allapot" [attr.data-a]="atadva('kikuldetes', r.id) ? 'kesz' : r.nyomtatva ? 'teljesitett' : 'piszkozat'">{{ atadva('kikuldetes', r.id) ? 'átadva' : r.nyomtatva ? 'átadható' : 'nincs lezárva' }}</span>
                <span class="gj-hiany" *ngIf="!r.ber_alkalmazott_id"> · nincs Bér-kötés</span></td>
            </tr>
            <tr *ngFor="let m of atad.atadhato.munkaba">
              <td>Munkába járás</td><td>{{ m.nev }}</td>
              <td>{{ fmtMax(m.km, 1) }} km × {{ fmt(m.ft_km) }} Ft/km · {{ m.utak_db }} út</td>
              <td class="num">{{ fmt(m.osszeg) }}</td>
              <td><span class="sz-allapot" [attr.data-a]="atadva('munkaba_jaras', m.sofor_id) ? 'kesz' : m.ber_kotve ? 'teljesitett' : 'hiba'">{{ atadva('munkaba_jaras', m.sofor_id) ? 'átadva' : m.ber_kotve ? 'átadható' : 'nincs Bér-kötés' }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tabla-wrap" *ngIf="atad.atadasok.length">
        <table class="n-racs sz-racs">
          <thead><tr><th>Átadva</th><th>Fajta</th><th>Dolgozó</th><th class="num">Összeg (Ft)</th><th>Bér-tétel</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let a of atad.atadasok" [class.halvany-sor]="a.visszavonva">
              <td>{{ huDatum(a.mikor) }} <span class="halvany">{{ a.ki }}</span></td>
              <td>{{ fajtaNev(a.fajta) }} {{ a.sorszam || '' }}</td>
              <td>{{ a.reszletek?.alkalmazott_nev || a.sofor_nev }}</td>
              <td class="num">{{ fmt(a.osszeg) }}</td>
              <td><ng-container *ngIf="a.visszavonva">visszavonva {{ huDatum(a.visszavonva) }}</ng-container>
                <ng-container *ngIf="!a.visszavonva"><span class="sz-allapot" [attr.data-a]="a.ber_megvan ? 'kesz' : 'figyelmeztetes'">{{ a.ber_megvan ? 'a Bérben' : 'a Bérben törölték' }}</span>
                  <span class="sz-allapot" *ngIf="a.veglegesitett" data-a="nincs">véglegesített hónap</span></ng-container></td>
              <td class="muv"><button type="button" class="ov-link" *ngIf="ir && !a.visszavonva && !a.veglegesitett" (click)="visszavon(a)">visszavonás</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>
</div>

<ion-modal [isOpen]="!!atadAblak" (didDismiss)="atadAblak = null" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Átadás a Bérbe – {{ ev }}. {{ honapok[ho - 1] }}</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="atadAblak">
        <p class="halvany" style="margin:0">A tételek a sofőr Bér-dolgozójának {{ ev }}. {{ honapok[ho - 1] }}i eseti tételei közé kerülnek: a kiküldetés a 155-ös (nem jövedelem), a munkába járás
          a 150-es (adómentes rész) és a 151-es (a mentes Ft/km feletti rész) jogcímre. Az újra-átadás a korábbit cseréli. Ha a hónap már számfejtve van, a Bérben mentsd újra.</p>
        <div class="sa-doboz" *ngIf="atad.atadhato.rendelvenyek.length">
          <b style="grid-column:1/-1">Kiküldetési rendelvények</b>
          <div class="sa-jelolok" style="grid-column:1/-1">
            <label *ngFor="let r of atad.atadhato.rendelvenyek" [title]="r.nyomtatva ? '' : 'Előbb nyomtasd ki (zárd le) a Kiküldetés fülön'">
              <input type="checkbox" [(ngModel)]="atadAblak.rendelvenyek[r.id]" [disabled]="!r.nyomtatva || !(r.fizetendo_ft > 0)">
              {{ r.sorszam }} · {{ r.sofor_nev }} · {{ fmt(r.fizetendo_ft) }} Ft<span class="halvany" *ngIf="!r.nyomtatva"> (nincs lezárva)</span><span class="halvany" *ngIf="atadva('kikuldetes', r.id)"> (csere)</span></label>
          </div>
        </div>
        <div class="sa-doboz" *ngIf="atad.atadhato.munkaba.length">
          <b style="grid-column:1/-1">Munkába járás saját autóval</b>
          <div class="sa-jelolok" style="grid-column:1/-1">
            <label *ngFor="let m of atad.atadhato.munkaba"><input type="checkbox" [(ngModel)]="atadAblak.soforok[m.sofor_id]" [disabled]="!m.sofor_id || !m.ber_kotve">
              {{ m.nev }} · {{ fmtMax(m.km, 1) }} km · {{ fmt(m.osszeg) }} Ft<span class="halvany" *ngIf="!m.ber_kotve"> (nincs Bér-kötés – a Sofőröknél add meg)</span><span class="halvany" *ngIf="atadva('munkaba_jaras', m.sofor_id)"> (csere)</span></label>
          </div>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" [disabled]="dolgozik || (!atadKijelolt.r.length && !atadKijelolt.s.length)" (click)="atadas()"><ion-icon name="arrow-redo-outline"></ion-icon>Átadás</button>
          <span class="spacer"></span><button type="button" class="ov-gomb" (click)="atadAblak = null">Mégsem</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
